export default "__VITE_ASSET__D8bOBeVs__"